import { CHART_COLORS } from "./ChartColors";

interface StatCardProps {
  title: string;
  current: number;
  previous: number | null;
  colClass?: string;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  current,
  previous,
  colClass = "col-md-3",
}) => {
  const getPercentageChange = (current: number, previous: number | null) => {
    if (
      previous === null ||
      previous === undefined ||
      previous === 0 ||
      current === undefined
    )
      return { value: "N/A", className: "text-muted", arrow: "" };

    const change = ((current - previous) / previous) * 100;
    const isPositive = change >= 0;

    return {
      value: `${Math.abs(change).toFixed(2)}%`,
      className: isPositive ? "text-success" : "text-danger",
      bgClassName: isPositive ? "bg-success-subtle" : "bg-danger-subtle",
      arrow: isPositive ? "↑" : "↓",
    };
  };

  const change = getPercentageChange(current, previous);

  return (
    <div className={colClass}>
      <div className="card h-100 border-0 shadow-sm">
        <div className="card-body">
          <div className="d-flex flex-column">
            <div className="text-muted small">{title}</div>
            <div className="d-flex align-items-center mt-2">
              <h3 className="mb-0 me-2" style={{ color: CHART_COLORS.PRIMARY }}>
                {(current ?? 0).toLocaleString()}
              </h3>
              <span
                className={`badge ${change.bgClassName} ${change.className}`}
              >
                {previous !== null && (
                  <>
                    {change.arrow} {change.value}
                  </>
                )}
              </span>
            </div>
            <div className="text-muted small mt-2">
              {previous != null && <>from {previous.toLocaleString()}</>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatCard;
